import { render, staticRenderFns } from "./Fooldal.vue?vue&type=template&id=e443e806&"
import script from "./Fooldal.vue?vue&type=script&lang=js&"
export * from "./Fooldal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports